module.exports = __webpack_public_path__ + "account/assets/phone.ade8483d.svg";